import React from "react";

const TresureSvg = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 302 252"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M237.752 225.64L257.607 100.964L80.4393 81.7114L0.818359 125.32L29.4755 225.841L214.36 251.403L237.752 225.64Z"
        fill="#FFE305"
      />
      <path
        d="M0.818359 125.28L225.694 146.18L257.647 100.964L80.4393 81.752L0.818359 125.28Z"
        fill="#FFB946"
      />
      <path
        opacity="0.2"
        d="M0.818359 125.28L257.647 100.964L80.4393 81.752L0.818359 125.28Z"
        fill="#A53D4C"
      />
      <path
        d="M128.348 148.551L125.133 227.449L205.437 239.828L212.43 158.117L128.348 148.551Z"
        fill="#FD9E03"
      />
      <path
        d="M20.5127 136.212L38.4787 214.185L105.399 224.515L107.007 146.06L20.5127 136.212Z"
        fill="#FD9E03"
      />
      <path
        d="M128.348 148.551L125.133 227.449L212.43 158.117L128.348 148.551Z"
        fill="#EE9606"
      />
      <path
        d="M157.89 188.1C157.849 188.1 157.809 188.1 157.769 188.1C157.287 188.1 156.885 187.658 156.885 187.176C156.925 186.694 157.327 186.292 157.809 186.292C158.332 186.332 158.693 186.734 158.693 187.216C158.693 187.699 158.372 188.06 157.89 188.1ZM161.386 187.297C161.025 187.337 160.663 187.136 160.502 186.814C160.301 186.372 160.502 185.809 160.944 185.608C161.386 185.408 161.949 185.608 162.15 186.051C162.391 186.493 162.19 187.015 161.748 187.256C161.587 187.256 161.507 187.256 161.386 187.297ZM154.433 187.136C154.272 187.136 154.071 187.096 153.951 187.055C153.509 186.814 153.348 186.292 153.549 185.85C153.79 185.408 154.312 185.247 154.755 185.448C155.197 185.689 155.357 186.211 155.157 186.654C155.036 186.935 154.755 187.096 154.433 187.136ZM164.32 185.166C164.079 185.207 163.798 185.126 163.597 184.885C163.235 184.523 163.235 183.961 163.597 183.599C163.959 183.237 164.521 183.237 164.883 183.599C165.245 183.961 165.245 184.523 164.883 184.885C164.722 185.046 164.521 185.126 164.32 185.166ZM151.539 184.965C151.298 185.006 151.017 184.885 150.816 184.724C150.454 184.363 150.454 183.8 150.776 183.438C151.137 183.076 151.7 183.076 152.062 183.438C152.423 183.76 152.423 184.363 152.102 184.724C151.941 184.885 151.74 184.965 151.539 184.965ZM166.491 182.273C166.33 182.273 166.129 182.232 165.968 182.152C165.526 181.871 165.365 181.348 165.647 180.906C165.888 180.464 166.451 180.303 166.893 180.584C167.335 180.826 167.455 181.388 167.214 181.83C167.013 182.112 166.772 182.232 166.491 182.273ZM149.168 182.232C148.846 182.273 148.525 182.152 148.364 181.871C148.083 181.469 148.163 180.906 148.565 180.584C148.967 180.303 149.53 180.384 149.811 180.785C150.092 181.187 150.012 181.75 149.61 182.072C149.489 182.152 149.329 182.192 149.168 182.232ZM168.018 178.977C167.857 178.977 167.737 178.977 167.616 178.937C167.134 178.776 166.933 178.253 167.094 177.771C167.254 177.289 167.777 177.088 168.259 177.249C168.701 177.409 168.942 177.932 168.782 178.414C168.661 178.736 168.38 178.977 168.018 178.977ZM147.279 179.138C146.917 179.178 146.555 178.977 146.395 178.655C146.153 178.213 146.314 177.65 146.756 177.449C147.198 177.208 147.721 177.369 147.962 177.811C148.203 178.253 148.042 178.816 147.6 179.057C147.52 179.097 147.399 179.138 147.279 179.138ZM169.103 175.52C168.983 175.52 168.902 175.52 168.782 175.48C168.299 175.359 168.018 174.877 168.139 174.395C168.259 173.913 168.742 173.631 169.224 173.752C169.706 173.872 169.987 174.355 169.867 174.837C169.787 175.199 169.465 175.48 169.103 175.52ZM145.752 175.842C145.39 175.882 144.988 175.641 144.827 175.279C144.626 174.837 144.867 174.314 145.35 174.114C145.792 173.913 146.314 174.154 146.515 174.596C146.716 175.078 146.475 175.56 146.033 175.802C145.912 175.842 145.832 175.842 145.752 175.842ZM169.787 171.943C169.706 171.943 169.626 171.943 169.586 171.943C169.103 171.863 168.742 171.421 168.822 170.938C168.902 170.456 169.344 170.094 169.867 170.175C170.349 170.255 170.711 170.697 170.631 171.179C170.55 171.622 170.188 171.903 169.787 171.943ZM144.506 172.425C144.104 172.466 143.702 172.224 143.541 171.823C143.38 171.34 143.662 170.818 144.144 170.697C144.626 170.577 145.108 170.818 145.269 171.3C145.43 171.782 145.149 172.265 144.666 172.425C144.666 172.425 144.586 172.425 144.506 172.425ZM170.148 168.366C170.108 168.366 170.068 168.366 169.987 168.366C169.505 168.326 169.143 167.884 169.143 167.401C169.184 166.879 169.626 166.517 170.108 166.557C170.59 166.598 170.952 167.04 170.952 167.522C170.952 167.964 170.631 168.326 170.148 168.366ZM143.581 168.929C143.139 168.969 142.697 168.647 142.617 168.205C142.496 167.723 142.817 167.241 143.3 167.12C143.782 166.999 144.264 167.321 144.385 167.803C144.506 168.286 144.184 168.768 143.702 168.888C143.662 168.929 143.621 168.929 143.581 168.929ZM170.309 164.709C170.269 164.709 170.269 164.709 170.229 164.709C169.746 164.709 169.344 164.307 169.344 163.824C169.344 163.302 169.746 162.9 170.269 162.9C170.751 162.9 171.153 163.302 171.153 163.824C171.113 164.307 170.751 164.668 170.309 164.709ZM142.898 165.392C142.416 165.432 142.014 165.11 141.933 164.628C141.853 164.146 142.174 163.663 142.657 163.583C143.139 163.503 143.621 163.824 143.702 164.307C143.782 164.789 143.461 165.271 142.978 165.352C142.938 165.352 142.898 165.392 142.898 165.392ZM170.188 161.091C169.666 161.131 169.224 160.729 169.184 160.247C169.143 159.765 169.545 159.323 170.028 159.283C170.55 159.242 170.952 159.644 170.992 160.127C171.032 160.649 170.671 161.051 170.188 161.091ZM142.456 161.774C141.933 161.815 141.531 161.453 141.491 160.971V160.93C141.491 160.89 141.491 160.89 141.491 160.85C141.451 160.328 141.813 159.926 142.295 159.885C142.817 159.845 143.219 160.207 143.26 160.689V160.77V160.81C143.3 161.292 142.938 161.734 142.456 161.774ZM169.867 157.474C169.385 157.514 168.942 157.193 168.902 156.71C168.862 156.228 169.184 155.786 169.706 155.705C170.188 155.625 170.671 155.987 170.711 156.509C170.751 156.951 170.389 157.393 169.867 157.474ZM142.215 157.996H142.174C141.652 157.996 141.25 157.635 141.25 157.112C141.25 156.63 141.652 156.188 142.134 156.188C142.657 156.188 143.059 156.59 143.059 157.072C143.059 157.554 142.697 157.956 142.215 157.996ZM169.304 153.897C168.862 153.937 168.42 153.615 168.34 153.133C168.259 152.651 168.541 152.168 169.063 152.088C169.545 152.008 170.028 152.329 170.108 152.812C170.229 153.294 169.867 153.776 169.385 153.857C169.344 153.857 169.344 153.897 169.304 153.897ZM142.255 154.379C142.215 154.379 142.174 154.379 142.134 154.379C141.612 154.339 141.25 153.937 141.25 153.455C141.29 152.932 141.692 152.57 142.174 152.57C142.697 152.611 143.059 153.013 143.059 153.535C143.059 153.977 142.697 154.339 142.255 154.379ZM168.541 150.32C168.098 150.36 167.697 150.079 167.576 149.636C167.455 149.154 167.737 148.672 168.219 148.551C168.701 148.431 169.184 148.712 169.344 149.194C169.465 149.677 169.184 150.159 168.701 150.32C168.621 150.32 168.581 150.32 168.541 150.32ZM142.576 150.762C142.536 150.762 142.456 150.762 142.375 150.762C141.893 150.681 141.531 150.239 141.572 149.757C141.652 149.275 142.094 148.913 142.576 148.953C143.059 149.034 143.42 149.476 143.34 149.958C143.34 150.4 142.978 150.722 142.576 150.762ZM167.496 146.863C167.094 146.903 166.692 146.662 166.531 146.26C166.37 145.778 166.652 145.255 167.094 145.135C167.576 144.974 168.098 145.215 168.259 145.698C168.42 146.14 168.179 146.662 167.697 146.823C167.656 146.823 167.576 146.863 167.496 146.863ZM143.139 147.185C143.059 147.185 142.938 147.185 142.858 147.185C142.375 147.064 142.054 146.582 142.174 146.099C142.295 145.617 142.737 145.296 143.219 145.416C143.702 145.497 144.023 145.979 143.943 146.461C143.862 146.863 143.541 147.144 143.139 147.185ZM166.209 143.487C165.848 143.527 165.446 143.326 165.285 142.964C165.084 142.522 165.285 142 165.767 141.759C166.209 141.558 166.732 141.759 166.933 142.201C167.134 142.643 166.933 143.206 166.491 143.407C166.37 143.447 166.29 143.447 166.209 143.487ZM144.063 143.688C143.943 143.688 143.822 143.688 143.702 143.648C143.219 143.487 142.938 143.005 143.099 142.522C143.26 142.04 143.742 141.799 144.224 141.96C144.707 142.12 144.948 142.603 144.787 143.085C144.747 143.407 144.425 143.648 144.063 143.688ZM164.521 140.231C164.2 140.272 163.838 140.111 163.677 139.789C163.436 139.347 163.557 138.784 163.999 138.543C164.401 138.302 164.963 138.423 165.245 138.865C165.486 139.307 165.365 139.829 164.923 140.071C164.803 140.191 164.682 140.231 164.521 140.231ZM145.39 140.312C145.229 140.312 145.068 140.312 144.948 140.231C144.506 139.99 144.305 139.468 144.506 139.026C144.707 138.583 145.269 138.383 145.711 138.584C146.153 138.784 146.354 139.347 146.153 139.789C145.993 140.111 145.711 140.272 145.39 140.312ZM162.431 137.297C162.15 137.338 161.828 137.217 161.668 136.976C161.346 136.574 161.386 136.011 161.788 135.69C162.15 135.368 162.753 135.408 163.034 135.81C163.356 136.212 163.316 136.775 162.914 137.096C162.793 137.217 162.632 137.297 162.431 137.297ZM147.198 137.177C146.997 137.177 146.797 137.137 146.596 137.016C146.194 136.735 146.113 136.172 146.395 135.73C146.676 135.328 147.239 135.248 147.641 135.529C148.043 135.81 148.123 136.373 147.842 136.775C147.721 137.016 147.48 137.137 147.198 137.177ZM159.779 134.846C159.578 134.846 159.377 134.805 159.176 134.645C158.774 134.363 158.693 133.801 158.935 133.399C159.256 132.997 159.779 132.916 160.221 133.198C160.623 133.479 160.703 134.042 160.422 134.444C160.261 134.685 160.02 134.805 159.779 134.846ZM149.731 134.564C149.449 134.604 149.128 134.444 148.927 134.203C148.605 133.801 148.686 133.238 149.087 132.916C149.489 132.635 150.052 132.715 150.374 133.077C150.695 133.479 150.615 134.042 150.213 134.363C150.012 134.484 149.891 134.564 149.731 134.564ZM156.563 133.238C156.443 133.238 156.362 133.238 156.242 133.198C155.759 133.077 155.478 132.555 155.599 132.072C155.719 131.59 156.242 131.309 156.724 131.429C157.206 131.55 157.488 132.072 157.367 132.555C157.206 132.957 156.885 133.198 156.563 133.238ZM152.946 133.037C152.504 133.077 152.062 132.756 151.981 132.314C151.901 131.831 152.182 131.349 152.665 131.269C153.147 131.188 153.629 131.469 153.71 131.952C153.83 132.434 153.509 132.916 153.026 132.997C153.026 132.997 152.986 133.037 152.946 133.037Z"
        fill="#FFCA08"
      />
      <path
        d="M20.5127 136.212L38.4787 214.185L107.007 146.06L20.5127 136.212Z"
        fill="#EE9606"
      />
      <path
        d="M222.438 229.901L233.13 207.433L242.816 135.409L227.382 152.973L222.438 229.901Z"
        fill="#FD9E03"
      />
      <path
        d="M80.4395 81.7517L257.647 100.964L270.549 13.4248L92.256 0.48291L80.4395 81.7517Z"
        fill="#FFE305"
      />
      <path
        d="M89.6836 17.9665C120.913 27.05 153.509 29.3811 183.412 31.5113C201.941 32.7975 220.831 34.2042 239.762 34.5659C248.966 34.7669 258.13 34.6865 267.414 34.3248L268.057 29.783C239.802 31.029 211.466 28.9792 183.774 26.9696C153.871 24.7992 121.275 22.5082 90.3267 13.3042L89.6836 17.9665Z"
        fill="#FD9E03"
      />
      <path
        d="M86.4277 40.8362C117.295 49.7589 149.61 51.9694 179.272 54.0996C197.801 55.4662 216.691 56.7925 235.622 57.1542C245.067 57.3552 254.633 57.2748 264.118 56.9131L264.841 52.291C236.224 53.6173 207.608 51.5675 179.634 49.5579C150.092 47.5081 117.738 45.2171 87.0708 36.2944L86.4277 40.8362Z"
        fill="#FD9E03"
      />
      <path
        d="M83.1318 63.7857C113.799 72.427 145.792 74.718 175.052 76.7678C193.58 78.054 212.471 79.4607 231.401 79.8224C241.208 80.0234 251.055 79.943 260.782 79.5009L261.425 74.8788C232.567 76.2855 203.669 74.1553 175.373 72.2261C146.113 70.0959 114.12 67.8853 83.7347 59.1636L83.1318 63.7857Z"
        fill="#FD9E03"
      />
      <path
        opacity="0.2"
        d="M127.223 76.0447C143.662 66.3181 160.623 57.2749 178.187 49.7589C195.831 42.2028 213.837 35.2897 232.607 31.0293C239.159 29.5422 245.83 28.4168 252.502 27.4924C257.165 26.8493 263.475 25.7239 268.62 26.8895L257.687 101.004L112.794 85.2889C117.456 82.0333 122.279 78.9385 127.223 76.0447Z"
        fill="#A53D4C"
      />
      <path
        d="M257.647 100.964C257.647 100.964 298.724 95.5378 301.136 60.7313C303.547 27.6128 270.509 13.3848 270.509 13.3848L257.647 100.964Z"
        fill="#FFE305"
      />
      <path
        d="M268.66 88.5042C278.507 84.5653 290.927 76.3661 292.052 60.048C293.137 44.8955 284.858 34.5661 277.502 28.4971L268.66 88.5042Z"
        fill="#FD9E03"
      />
      <path
        d="M226.016 100.361L225.935 105.104C225.734 112.941 262.51 113.705 262.752 105.867L262.832 101.125L226.016 100.361Z"
        fill="#FA9C1E"
      />
      <path
        d="M226.016 100.361C225.936 103.335 234.175 105.907 244.344 106.108C254.513 106.309 262.752 104.059 262.832 101.084C262.913 98.1101 254.754 95.5378 244.585 95.3369C234.416 95.1761 226.097 97.3867 226.016 100.361Z"
        fill="#FFCA08"
      />
      <path
        d="M230.075 100.441C229.995 103.496 237.149 104.3 244.383 104.461C251.578 104.621 258.732 104.018 258.772 101.044C258.853 98.0699 251.698 97.1857 244.504 97.0249C237.309 96.8642 230.155 97.3867 230.075 100.441Z"
        fill="#FA9C1E"
      />
      <path
        d="M209.899 111.575L209.818 116.317C209.617 124.155 246.393 124.919 246.634 117.081L246.715 112.338L209.899 111.575Z"
        fill="#FA9C1E"
      />
      <path
        d="M209.899 111.575C209.819 114.549 218.058 117.121 228.227 117.322C238.395 117.523 246.635 115.272 246.715 112.298C246.796 109.324 238.637 106.752 228.468 106.551C218.299 106.35 209.979 108.6 209.899 111.575Z"
        fill="#FFCA08"
      />
      <path
        d="M213.998 111.655C213.917 114.71 221.072 115.514 228.306 115.674C235.501 115.835 242.655 115.232 242.695 112.258C242.775 109.284 235.621 108.4 228.427 108.239C221.192 108.078 214.038 108.601 213.998 111.655Z"
        fill="#FA9C1E"
      />
      <path
        d="M200.735 96.1807L200.654 100.923C200.453 108.761 237.229 109.525 237.47 101.687L237.551 96.9443L200.735 96.1807Z"
        fill="#FA9C1E"
      />
      <path
        d="M200.735 96.1806C200.655 99.1548 208.894 101.727 219.063 101.928C229.231 102.129 237.471 99.8783 237.551 96.904C237.631 93.9298 229.472 91.3575 219.304 91.1565C209.095 90.9556 200.815 93.2063 200.735 96.1806Z"
        fill="#FFCA08"
      />
      <path
        d="M204.794 96.2611C204.713 99.3157 211.867 100.12 219.102 100.28C226.297 100.441 233.451 99.8382 233.491 96.864C233.571 93.8898 226.417 93.0055 219.223 92.8448C212.028 92.684 204.874 93.2065 204.794 96.2611Z"
        fill="#FA9C1E"
      />
      <path
        d="M186.145 108.439L186.064 113.182C185.863 121.02 222.639 121.783 222.88 113.946L222.961 109.203L186.145 108.439Z"
        fill="#FA9C1E"
      />
      <path
        d="M186.145 108.439C186.065 111.414 194.304 113.986 204.473 114.187C214.641 114.388 222.881 112.137 222.961 109.163C223.042 106.189 214.883 103.616 204.714 103.415C194.505 103.255 186.225 105.505 186.145 108.439Z"
        fill="#FFCA08"
      />
      <path
        d="M190.204 108.56C190.123 111.615 197.278 112.419 204.512 112.579C211.707 112.74 218.861 112.137 218.901 109.163C218.981 106.189 211.827 105.305 204.633 105.144C197.438 104.943 190.284 105.506 190.204 108.56Z"
        fill="#FA9C1E"
      />
      <path
        d="M205.035 122.145L204.955 126.888C204.754 134.725 241.53 135.489 241.771 127.651L241.851 122.909L205.035 122.145Z"
        fill="#FA9C1E"
      />
      <path
        d="M205.036 122.145C204.955 125.119 213.195 127.691 223.363 127.892C233.532 128.093 241.771 125.843 241.852 122.868C241.932 119.894 233.773 117.322 223.605 117.121C213.396 116.96 205.076 119.211 205.036 122.145Z"
        fill="#FFCA08"
      />
      <path
        d="M209.094 122.225C209.014 125.28 216.168 126.084 223.403 126.245C230.597 126.405 237.752 125.802 237.792 122.828C237.872 119.854 230.718 118.97 223.523 118.809C216.289 118.648 209.135 119.211 209.094 122.225Z"
        fill="#FA9C1E"
      />
      <path
        d="M191.049 134.564L190.969 139.307C190.768 147.145 227.544 147.908 227.785 140.071L227.865 135.328L191.049 134.564Z"
        fill="#FA9C1E"
      />
      <path
        d="M191.049 134.564C190.969 137.539 199.208 140.111 209.377 140.312C219.546 140.513 227.785 138.262 227.866 135.288C227.946 132.314 219.787 129.741 209.618 129.54C199.409 129.339 191.09 131.59 191.049 134.564Z"
        fill="#FFCA08"
      />
      <path
        d="M195.108 134.645C195.028 137.7 202.182 138.503 209.417 138.664C216.611 138.825 223.765 138.222 223.805 135.248C223.886 132.274 216.732 131.389 209.537 131.229C202.303 131.068 195.148 131.59 195.108 134.645Z"
        fill="#FA9C1E"
      />
      <path
        d="M178.709 119.895L178.629 124.637C178.428 132.475 215.204 133.238 215.445 125.401L215.525 120.658L178.709 119.895Z"
        fill="#FA9C1E"
      />
      <path
        d="M178.71 119.894C178.629 122.869 186.869 125.441 197.037 125.642C207.206 125.843 215.445 123.592 215.526 120.618C215.606 117.644 207.447 115.071 197.278 114.87C187.11 114.669 178.79 116.92 178.71 119.894Z"
        fill="#FFCA08"
      />
      <path
        d="M182.809 119.975C182.729 123.03 189.883 123.833 197.118 123.994C204.312 124.155 211.466 123.552 211.507 120.578C211.587 117.604 204.433 116.719 197.238 116.559C190.004 116.398 182.849 116.92 182.809 119.975Z"
        fill="#FA9C1E"
      />
      <path
        d="M165.165 135.127L165.085 139.87C164.884 147.707 201.66 148.471 201.901 140.633L201.981 135.891L165.165 135.127Z"
        fill="#FA9C1E"
      />
      <path
        d="M165.166 135.127C165.085 138.101 173.325 140.674 183.493 140.875C193.662 141.075 201.901 138.825 201.982 135.85C202.062 132.876 193.903 130.304 183.734 130.103C173.566 129.942 165.246 132.153 165.166 135.127Z"
        fill="#FFCA08"
      />
      <path
        d="M169.264 135.207C169.184 138.262 176.338 139.066 183.573 139.227C190.767 139.387 197.921 138.785 197.962 135.81C198.042 132.836 190.888 131.952 183.693 131.791C176.459 131.63 169.305 132.153 169.264 135.207Z"
        fill="#FA9C1E"
      />
      <path
        d="M163.918 97.0649L163.798 101.808C163.597 109.645 200.373 110.409 200.614 102.571L200.694 97.8286L163.918 97.0649Z"
        fill="#FA9C1E"
      />
      <path
        d="M163.919 97.0648C163.838 100.039 172.078 102.611 182.246 102.812C192.415 103.013 200.654 100.763 200.735 97.7883C200.815 94.8141 192.656 92.2418 182.487 92.0408C172.319 91.8398 163.959 94.0906 163.919 97.0648Z"
        fill="#FFCA08"
      />
      <path
        d="M167.977 97.1454C167.897 100.2 175.051 101.004 182.286 101.165C189.48 101.325 196.634 100.722 196.675 97.7483C196.715 94.774 189.601 93.8898 182.406 93.729C175.172 93.5683 168.017 94.0908 167.977 97.1454Z"
        fill="#FA9C1E"
      />
      <path
        d="M151.419 107.756L151.339 112.499C151.138 120.337 187.914 121.1 188.155 113.263L188.235 108.52L151.419 107.756Z"
        fill="#FA9C1E"
      />
      <path
        d="M151.42 107.756C151.339 110.73 159.579 113.303 169.747 113.504C179.916 113.705 188.155 111.454 188.236 108.48C188.316 105.505 180.157 102.933 169.988 102.732C159.82 102.531 151.46 104.782 151.42 107.756Z"
        fill="#FFCA08"
      />
      <path
        d="M155.478 107.837C155.398 110.891 162.552 111.695 169.787 111.856C176.981 112.017 184.135 111.414 184.176 108.44C184.256 105.465 177.102 104.581 169.907 104.42C162.673 104.26 155.518 104.782 155.478 107.837Z"
        fill="#FA9C1E"
      />
      <path
        d="M151.78 123.752L151.7 128.495C151.499 136.333 188.275 137.096 188.516 129.259L188.597 124.516L151.78 123.752Z"
        fill="#FA9C1E"
      />
      <path
        d="M151.781 123.752C151.7 126.727 159.94 129.299 170.109 129.5C180.277 129.701 188.517 127.45 188.597 124.476C188.677 121.502 180.518 118.929 170.35 118.728C160.181 118.568 151.861 120.778 151.781 123.752Z"
        fill="#FFCA08"
      />
      <path
        d="M155.84 123.833C155.759 126.887 162.913 127.691 170.148 127.852C177.342 128.013 184.497 127.41 184.537 124.436C184.617 121.461 177.463 120.577 170.269 120.416C163.074 120.256 155.92 120.818 155.84 123.833Z"
        fill="#FA9C1E"
      />
      <path
        d="M132.609 127.008L132.528 131.751C132.327 139.588 169.103 140.352 169.344 132.515L169.425 127.772L132.609 127.008Z"
        fill="#FA9C1E"
      />
      <path
        d="M132.609 127.008C132.529 129.982 140.768 132.555 150.937 132.756C161.105 132.957 169.345 130.706 169.425 127.732C169.506 124.757 161.346 122.185 151.178 121.984C140.969 121.783 132.649 124.034 132.609 127.008Z"
        fill="#FFCA08"
      />
      <path
        d="M136.668 127.089C136.587 130.143 143.742 130.947 150.976 131.108C158.171 131.269 165.325 130.666 165.365 127.692C165.445 124.717 158.291 123.833 151.097 123.672C143.862 123.512 136.748 124.034 136.668 127.089Z"
        fill="#FA9C1E"
      />
      <path
        d="M133.131 100.16L133.051 104.903C132.85 112.74 169.626 113.504 169.867 105.666L169.947 100.924L133.131 100.16Z"
        fill="#FA9C1E"
      />
      <path
        d="M133.131 100.16C133.051 103.134 141.29 105.707 151.459 105.908C161.628 106.109 169.867 103.858 169.948 100.884C170.028 97.9093 161.869 95.337 151.7 95.136C141.532 94.935 133.212 97.1858 133.131 100.16Z"
        fill="#FFCA08"
      />
      <path
        d="M137.23 100.241C137.15 103.295 144.304 104.099 151.539 104.26C158.733 104.421 165.887 103.818 165.927 100.843C166.008 97.8693 158.854 96.985 151.659 96.8243C144.425 96.6635 137.27 97.186 137.23 100.241Z"
        fill="#FA9C1E"
      />
      <path
        d="M140.205 115.513L140.125 120.256C139.924 128.093 176.7 128.857 176.941 121.02L177.021 116.277L140.205 115.513Z"
        fill="#FA9C1E"
      />
      <path
        d="M140.206 115.513C140.125 118.487 148.365 121.06 158.533 121.261C168.702 121.462 176.941 119.211 177.022 116.237C177.102 113.262 168.943 110.69 158.775 110.489C148.606 110.288 140.286 112.539 140.206 115.513Z"
        fill="#FFCA08"
      />
      <path
        d="M144.264 115.594C144.184 118.648 151.338 119.452 158.573 119.613C165.767 119.774 172.921 119.171 172.962 116.197C173.002 113.222 165.888 112.338 158.693 112.177C151.499 112.017 144.345 112.539 144.264 115.594Z"
        fill="#FA9C1E"
      />
      <path
        d="M135.021 91.1567L134.94 95.8994C134.739 103.737 171.515 104.501 171.756 96.6631L171.837 91.9204L135.021 91.1567Z"
        fill="#FA9C1E"
      />
      <path
        d="M135.021 91.1566C134.941 94.1309 143.18 96.7032 153.349 96.9041C163.517 97.1051 171.757 94.8543 171.837 91.8801C171.918 88.9059 163.759 86.3336 153.59 86.1326C143.421 85.9316 135.061 88.1824 135.021 91.1566Z"
        fill="#FFCA08"
      />
      <path
        d="M139.08 91.2372C138.999 94.2918 146.154 95.0956 153.388 95.2564C160.583 95.4172 167.737 94.8143 167.777 91.8401C167.857 88.8658 160.703 87.9816 153.509 87.8208C146.314 87.6601 139.16 88.1826 139.08 91.2372Z"
        fill="#FA9C1E"
      />
      <path
        d="M117.899 113.383L117.818 118.126C117.617 125.963 154.393 126.727 154.634 118.89L154.715 114.147L117.899 113.383Z"
        fill="#FA9C1E"
      />
      <path
        d="M117.899 113.383C117.819 116.357 126.058 118.93 136.227 119.131C146.395 119.332 154.635 117.081 154.715 114.107C154.796 111.132 146.637 108.56 136.468 108.359C126.299 108.158 117.979 110.409 117.899 113.383Z"
        fill="#FFCA08"
      />
      <path
        d="M121.958 113.464C121.877 116.518 129.032 117.322 136.266 117.483C143.461 117.644 150.615 117.041 150.655 114.067C150.735 111.092 143.581 110.208 136.387 110.047C129.192 109.887 122.038 110.409 121.958 113.464Z"
        fill="#FA9C1E"
      />
      <path
        d="M139.964 128.294L139.884 133.037C139.683 140.875 176.459 141.638 176.7 133.801L176.78 129.058L139.964 128.294Z"
        fill="#FA9C1E"
      />
      <path
        d="M139.964 128.254C139.884 131.228 148.123 133.801 158.292 134.002C168.461 134.203 176.7 131.952 176.781 128.978C176.861 126.003 168.702 123.431 158.533 123.23C148.365 123.029 140.005 125.32 139.964 128.254Z"
        fill="#FFCA08"
      />
      <path
        d="M144.023 128.375C143.943 131.429 151.097 132.233 158.332 132.394C165.526 132.555 172.68 131.952 172.72 128.978C172.761 126.003 165.647 125.119 158.452 124.958C151.218 124.757 144.063 125.32 144.023 128.375Z"
        fill="#FA9C1E"
      />
      <path
        d="M157.77 109.525L157.689 114.268C157.488 122.105 194.264 122.869 194.505 115.031L194.586 110.289L157.77 109.525Z"
        fill="#FA9C1E"
      />
      <path
        d="M157.77 109.525C157.69 112.499 165.929 115.071 176.098 115.272C186.266 115.473 194.506 113.222 194.586 110.248C194.667 107.274 186.508 104.702 176.339 104.501C166.17 104.3 157.81 106.551 157.77 109.525Z"
        fill="#FFCA08"
      />
      <path
        d="M161.829 109.605C161.748 112.66 168.903 113.464 176.137 113.625C183.332 113.785 190.486 113.182 190.526 110.208C190.566 107.234 183.452 106.35 176.258 106.189C169.063 106.028 161.909 106.551 161.829 109.605Z"
        fill="#FA9C1E"
      />
      <path
        d="M170.912 122.426L170.832 127.169C170.631 135.006 207.407 135.77 207.648 127.933L207.728 123.19L170.912 122.426Z"
        fill="#FA9C1E"
      />
      <path
        d="M170.913 122.426C170.832 125.4 179.072 127.973 189.24 128.174C199.409 128.375 207.648 126.124 207.729 123.15C207.809 120.175 199.65 117.603 189.482 117.402C179.273 117.201 170.953 119.452 170.913 122.426Z"
        fill="#FFCA08"
      />
      <path
        d="M174.971 122.507C174.891 125.561 182.045 126.365 189.28 126.526C196.474 126.687 203.628 126.084 203.669 123.11C203.749 120.135 196.595 119.251 189.4 119.09C182.166 118.93 175.052 119.452 174.971 122.507Z"
        fill="#FA9C1E"
      />
      <path
        d="M191.008 105.626L190.928 110.369C190.727 118.206 227.503 118.97 227.744 111.132L227.824 106.39L191.008 105.626Z"
        fill="#FA9C1E"
      />
      <path
        d="M191.008 105.626C190.928 108.6 199.167 111.172 209.336 111.373C219.505 111.574 227.744 109.324 227.825 106.349C227.905 103.375 219.746 100.803 209.577 100.602C199.409 100.401 191.089 102.652 191.008 105.626Z"
        fill="#FFCA08"
      />
      <path
        d="M195.067 105.706C194.987 108.761 202.141 109.565 209.376 109.726C216.57 109.886 223.724 109.284 223.764 106.309C223.845 103.335 216.691 102.451 209.496 102.29C202.302 102.129 195.147 102.652 195.067 105.706Z"
        fill="#FA9C1E"
      />
      <path
        d="M198.926 122.105L198.846 126.848C198.645 134.685 235.421 135.449 235.662 127.611L235.742 122.869L198.926 122.105Z"
        fill="#FA9C1E"
      />
      <path
        d="M198.926 122.105C198.846 125.079 207.085 127.651 217.254 127.852C227.423 128.053 235.662 125.803 235.743 122.828C235.823 119.854 227.664 117.282 217.495 117.081C207.327 116.88 199.007 119.131 198.926 122.105Z"
        fill="#FFCA08"
      />
      <path
        d="M202.985 122.185C202.905 125.24 210.059 126.044 217.294 126.205C224.488 126.365 231.642 125.763 231.682 122.788C231.723 119.814 224.609 118.93 217.414 118.769C210.22 118.608 203.065 119.131 202.985 122.185Z"
        fill="#FA9C1E"
      />
      <path
        d="M178.468 134.283L178.388 139.026C178.187 146.863 214.963 147.627 215.204 139.79L215.284 135.047L178.468 134.283Z"
        fill="#FA9C1E"
      />
      <path
        d="M178.468 134.283C178.388 137.257 186.627 139.83 196.796 140.031C206.965 140.232 215.204 137.981 215.285 135.007C215.365 132.032 207.206 129.46 197.037 129.259C186.828 129.098 178.509 131.349 178.468 134.283Z"
        fill="#FFCA08"
      />
      <path
        d="M182.527 134.403C182.447 137.458 189.601 138.262 196.835 138.423C204.03 138.583 211.184 137.981 211.224 135.006C211.305 132.032 204.15 131.148 196.956 130.987C189.721 130.786 182.607 131.349 182.527 134.403Z"
        fill="#FA9C1E"
      />
      <path
        d="M132.207 117.965L132.127 122.708C131.926 130.546 168.702 131.309 168.943 123.472L169.023 118.729L132.207 117.965Z"
        fill="#FA9C1E"
      />
      <path
        d="M132.208 117.965C132.127 120.939 140.367 123.512 150.535 123.713C160.704 123.914 168.943 121.663 169.024 118.689C169.104 115.714 160.945 113.142 150.776 112.941C140.608 112.78 132.288 115.031 132.208 117.965Z"
        fill="#FFCA08"
      />
      <path
        d="M136.266 118.046C136.186 121.1 143.34 121.904 150.575 122.065C157.769 122.226 164.923 121.623 164.964 118.649C165.044 115.674 157.89 114.79 150.695 114.629C143.501 114.469 136.347 115.031 136.266 118.046Z"
        fill="#FA9C1E"
      />
      <path
        d="M106.162 84.2437L106.082 88.9863C105.881 96.8238 142.657 97.5875 142.898 89.75L142.978 85.0073L106.162 84.2437Z"
        fill="#FA9C1E"
      />
      <path
        d="M106.163 84.2435C106.082 87.2178 114.322 89.7901 124.49 89.991C134.659 90.192 142.898 87.9412 142.979 84.967C143.059 81.9928 134.9 79.4205 124.732 79.2195C114.563 79.0185 106.243 81.2693 106.163 84.2435Z"
        fill="#FFCA08"
      />
      <path
        d="M110.221 84.3239C110.141 87.3785 117.295 88.1823 124.53 88.3431C131.724 88.5039 138.878 87.901 138.919 84.9267C138.999 81.9525 131.845 81.0683 124.65 80.9075C117.456 80.7065 110.302 81.2692 110.221 84.3239Z"
        fill="#FA9C1E"
      />
      <path
        d="M105.841 101.446L105.761 106.189C105.56 114.026 142.336 114.79 142.577 106.953L142.657 102.21L105.841 101.446Z"
        fill="#FA9C1E"
      />
      <path
        d="M105.841 101.446C105.761 104.42 114 106.993 124.169 107.194C134.338 107.395 142.577 105.144 142.658 102.17C142.738 99.1954 134.579 96.6231 124.41 96.4221C114.242 96.2212 105.922 98.472 105.841 101.446Z"
        fill="#FFCA08"
      />
      <path
        d="M109.9 101.527C109.82 104.581 116.974 105.385 124.209 105.546C131.403 105.707 138.557 105.104 138.597 102.13C138.678 99.1554 131.524 98.2712 124.329 98.1104C117.135 97.9496 109.98 98.4721 109.9 101.527Z"
        fill="#FA9C1E"
      />
      <path
        d="M74.7316 84.686L74.6512 89.4287C74.4502 97.2662 111.226 98.0299 111.467 90.1924L111.548 85.4497L74.7316 84.686Z"
        fill="#FA9C1E"
      />
      <path
        d="M74.732 84.6859C74.6516 87.6602 82.8911 90.2325 93.0597 90.4334C103.228 90.6344 111.468 88.3836 111.548 85.4094C111.629 82.4351 103.47 79.8629 93.3009 79.6619C83.1322 79.4609 74.8124 81.7117 74.732 84.6859Z"
        fill="#FFCA08"
      />
      <path
        d="M78.7907 84.7665C78.7103 87.8211 85.8646 88.6249 93.0992 88.7857C100.294 88.9465 107.448 88.3436 107.488 85.3694C107.568 82.3951 100.414 81.5109 93.2197 81.3501C86.0253 81.1894 78.8711 81.7119 78.7907 84.7665Z"
        fill="#FA9C1E"
      />
      <path
        d="M99.9728 90.4336L99.8924 95.1763C99.6915 103.014 136.467 103.777 136.709 95.94L136.789 91.1973L99.9728 90.4336Z"
        fill="#FA9C1E"
      />
      <path
        d="M99.9732 90.4335C99.8929 93.4077 108.132 95.98 118.301 96.181C128.47 96.3819 136.709 94.1312 136.789 91.1569C136.87 88.1827 128.711 85.6104 118.542 85.4094C108.373 85.2085 100.013 87.4593 99.9732 90.4335Z"
        fill="#FFCA08"
      />
      <path
        d="M104.032 90.5139C103.952 93.5685 111.106 94.3724 118.34 94.5331C125.535 94.6939 132.689 94.091 132.729 91.1168C132.81 88.1426 125.655 87.2583 118.461 87.0976C111.226 86.9368 104.112 87.4995 104.032 90.5139Z"
        fill="#FA9C1E"
      />
      <path
        d="M75.6964 96.3818L75.6161 101.125C75.4151 108.962 112.191 109.726 112.432 101.888L112.513 97.1455L75.6964 96.3818Z"
        fill="#FA9C1E"
      />
      <path
        d="M75.6969 96.3817C75.6165 99.356 83.8559 101.928 94.0246 102.129C104.193 102.33 112.433 100.079 112.513 97.1052C112.593 94.131 104.434 91.5587 94.2657 91.3577C84.0971 91.1567 75.7773 93.4075 75.6969 96.3817Z"
        fill="#FFCA08"
      />
      <path
        d="M79.7956 96.4623C79.7152 99.5169 86.8694 100.321 94.1041 100.482C101.298 100.642 108.453 100.039 108.493 97.0652C108.573 94.0909 101.419 93.2067 94.2246 93.0459C86.99 92.8852 79.8358 93.4077 79.7956 96.4623Z"
        fill="#FA9C1E"
      />
      <path
        d="M56.1632 92.2422L56.0829 96.9849C55.8819 104.822 92.6578 105.586 92.899 97.7485L92.9794 93.0059L56.1632 92.2422Z"
        fill="#FA9C1E"
      />
      <path
        d="M56.1637 92.2421C56.0833 95.2163 64.3227 97.7886 74.4914 97.9896C84.66 98.1905 92.8994 95.9398 92.9798 92.9655C93.0602 89.9913 84.9012 87.419 74.7325 87.218C64.5639 87.0171 56.2441 89.2679 56.1637 92.2421Z"
        fill="#FFCA08"
      />
      <path
        d="M60.2624 92.3226C60.182 95.3772 67.3362 96.1811 74.5709 96.3419C81.7653 96.5026 88.9195 95.8997 88.9597 92.9255C89.0401 89.9513 81.8859 89.0671 74.6914 88.9063C67.4568 88.7455 60.3026 89.268 60.2624 92.3226Z"
        fill="#FA9C1E"
      />
      <path
        d="M72.923 109.726L72.8426 114.468C72.6417 122.306 109.418 123.069 109.659 115.232L109.739 110.489L72.923 109.726Z"
        fill="#FA9C1E"
      />
      <path
        d="M72.9234 109.725C72.8431 112.7 81.0825 115.272 91.2511 115.473C101.42 115.674 109.659 113.423 109.74 110.449C109.82 107.475 101.661 104.902 91.4923 104.701C81.3236 104.5 73.0038 106.751 72.9234 109.725Z"
        fill="#FFCA08"
      />
      <path
        d="M76.9821 109.806C76.9017 112.861 84.056 113.664 91.2906 113.825C98.485 113.986 105.639 113.383 105.679 110.409C105.76 107.435 98.6056 106.55 91.4112 106.39C84.2167 106.229 77.0625 106.751 76.9821 109.806Z"
        fill="#FA9C1E"
      />
      <path
        d="M93.8234 111.896L93.743 116.639C93.542 124.476 130.318 125.24 130.559 117.402L130.64 112.66L93.8234 111.896Z"
        fill="#FA9C1E"
      />
      <path
        d="M93.8238 111.896C93.7434 114.87 101.983 117.442 112.152 117.643C122.32 117.844 130.56 115.594 130.64 112.619C130.72 109.645 122.561 107.073 112.393 106.872C102.224 106.671 93.864 108.922 93.8238 111.896Z"
        fill="#FFCA08"
      />
      <path
        d="M97.8825 111.976C97.8021 115.031 104.956 115.835 112.191 115.996C119.385 116.156 126.54 115.554 126.58 112.579C126.66 109.605 119.506 108.721 112.312 108.56C105.077 108.399 97.9227 108.922 97.8825 111.976Z"
        fill="#FA9C1E"
      />
      <path
        d="M99.2492 126.325L99.1688 131.068C98.9678 138.905 135.744 139.669 135.985 131.832L136.065 127.089L99.2492 126.325Z"
        fill="#FA9C1E"
      />
      <path
        d="M99.2496 126.325C99.1692 129.299 107.409 131.872 117.577 132.073C127.746 132.274 135.985 130.023 136.066 127.049C136.146 124.074 127.987 121.502 117.818 121.301C107.65 121.14 99.33 123.351 99.2496 126.325Z"
        fill="#FFCA08"
      />
      <path
        d="M103.348 126.406C103.268 129.46 110.422 130.264 117.657 130.425C124.851 130.586 132.005 129.983 132.046 127.009C132.086 124.034 124.972 123.15 117.777 122.989C110.543 122.829 103.389 123.351 103.348 126.406Z"
        fill="#FA9C1E"
      />
      <path
        d="M44.1457 112.941L44.0653 117.684C43.8643 125.521 80.6403 126.285 80.8814 118.447L80.9618 113.705L44.1457 112.941Z"
        fill="#FA9C1E"
      />
      <path
        d="M44.1461 112.941C44.0657 115.915 52.3051 118.487 62.4738 118.688C72.6424 118.889 80.8819 116.639 80.9623 113.664C81.0426 110.69 72.8836 108.118 62.7149 107.917C52.5463 107.716 44.2265 109.967 44.1461 112.941Z"
        fill="#FFCA08"
      />
      <path
        d="M48.2448 113.021C48.1644 116.076 55.3187 116.88 62.5533 117.041C69.7477 117.201 76.9019 116.598 76.9421 113.624C77.0225 110.65 69.8683 109.766 62.6738 109.605C55.4392 109.444 48.285 109.967 48.2448 113.021Z"
        fill="#FA9C1E"
      />
      <path
        d="M47.2804 104.742L47.2 109.484C46.9991 117.322 83.775 118.086 84.0162 110.248L84.0966 105.505L47.2804 104.742Z"
        fill="#FA9C1E"
      />
      <path
        d="M47.2809 104.742C47.2005 107.716 55.4399 110.288 65.6086 110.489C75.7772 110.69 84.0166 108.439 84.097 105.465C84.1774 102.491 76.0184 99.9185 65.8497 99.7176C55.681 99.5166 47.3612 101.767 47.2809 104.742Z"
        fill="#FFCA08"
      />
      <path
        d="M51.3796 104.822C51.2992 107.877 58.4534 108.681 65.688 108.841C72.8825 109.002 80.0367 108.399 80.0769 105.425C80.1573 102.451 73.003 101.567 65.8086 101.406C58.574 101.245 51.4198 101.768 51.3796 104.822Z"
        fill="#FA9C1E"
      />
      <path
        d="M42.4572 121.663L42.3768 126.405C42.1758 134.243 78.9518 135.006 79.193 127.169L79.2733 122.426L42.4572 121.663Z"
        fill="#FA9C1E"
      />
      <path
        d="M42.4576 121.663C42.3772 124.637 50.6167 127.209 60.7853 127.41C70.954 127.611 79.1934 125.36 79.2738 122.386C79.3542 119.412 71.1951 116.84 61.0265 116.639C50.8176 116.478 42.4978 118.688 42.4576 121.663Z"
        fill="#FFCA08"
      />
      <path
        d="M46.5163 121.743C46.4359 124.798 53.5901 125.601 60.8248 125.762C68.0192 125.923 75.1734 125.32 75.2136 122.346C75.2538 119.372 68.1398 118.487 60.9453 118.327C53.7107 118.166 46.5967 118.728 46.5163 121.743Z"
        fill="#FA9C1E"
      />
      <path
        d="M70.0294 118.849L69.9491 123.592C69.7481 131.429 106.524 132.193 106.765 124.355L106.846 119.613L70.0294 118.849Z"
        fill="#FA9C1E"
      />
      <path
        d="M70.0299 118.849C69.9495 121.823 78.1889 124.396 88.3576 124.597C98.5262 124.797 106.766 122.547 106.846 119.572C106.926 116.598 98.7674 114.026 88.5987 113.825C78.4301 113.624 70.1103 115.875 70.0299 118.849Z"
        fill="#FFCA08"
      />
      <path
        d="M74.0886 118.93C74.0082 121.984 81.1624 122.788 88.397 122.949C95.5915 123.11 102.746 122.507 102.786 119.532C102.866 116.558 95.712 115.674 88.5176 115.513C81.3232 115.352 74.1689 115.875 74.0886 118.93Z"
        fill="#FA9C1E"
      />
      <path
        d="M72.5216 131.389L72.4413 136.132C72.2403 143.969 109.016 144.733 109.257 136.896L109.338 132.153L72.5216 131.389Z"
        fill="#FA9C1E"
      />
      <path
        d="M72.5221 131.389C72.4417 134.363 80.6811 136.936 90.8498 137.137C101.018 137.338 109.258 135.087 109.338 132.113C109.419 129.138 101.26 126.566 91.0909 126.365C80.8821 126.204 72.6025 128.415 72.5221 131.389Z"
        fill="#FFCA08"
      />
      <path
        d="M76.5807 131.469C76.5004 134.524 83.6546 135.328 90.8892 135.489C98.0836 135.649 105.238 135.047 105.278 132.072C105.318 129.098 98.2042 128.214 91.0098 128.053C83.8154 127.892 76.6611 128.455 76.5807 131.469Z"
        fill="#FA9C1E"
      />
      <path
        d="M22.1603 118.97L22.0799 123.712C21.879 131.55 58.6549 132.314 58.8961 124.476L58.9765 119.733L22.1603 118.97Z"
        fill="#FA9C1E"
      />
      <path
        d="M22.1607 118.97C22.0804 121.944 30.3198 124.516 40.4884 124.717C50.6571 124.918 58.8965 122.667 58.9769 119.693C59.0573 116.719 50.8982 114.147 40.7296 113.946C30.5609 113.745 22.2411 115.995 22.1607 118.97Z"
        fill="#FFCA08"
      />
      <path
        d="M26.2595 119.05C26.1791 122.105 33.3333 122.909 40.5679 123.069C47.7623 123.23 54.9166 122.627 54.9568 119.653C55.0371 116.679 47.8829 115.795 40.6885 115.634C33.4539 115.473 26.2997 115.996 26.2595 119.05Z"
        fill="#FA9C1E"
      />
      <path
        d="M33.6554 98.2705L33.575 103.013C33.3741 110.851 70.15 111.614 70.3912 103.777L70.4716 99.0342L33.6554 98.2705Z"
        fill="#FA9C1E"
      />
      <path
        d="M33.6559 98.2706C33.5755 101.245 41.8149 103.817 51.9835 104.018C62.1522 104.219 70.3916 101.968 70.472 98.994C70.5524 96.0198 62.3934 93.4475 52.2247 93.2465C42.0159 93.0858 33.696 95.2963 33.6559 98.2706Z"
        fill="#FFCA08"
      />
      <path
        d="M37.7145 98.3509C37.6342 101.406 44.7884 102.209 52.023 102.37C59.2174 102.531 66.3717 101.928 66.4118 98.9538C66.4922 95.9796 59.338 95.0954 52.1436 94.9346C44.909 94.7738 37.7547 95.2963 37.7145 98.3509Z"
        fill="#FA9C1E"
      />
      <path
        d="M13.8009 108.52L13.7205 113.263C13.5196 121.1 50.2955 121.864 50.5367 114.026L50.6171 109.284L13.8009 108.52Z"
        fill="#FA9C1E"
      />
      <path
        d="M13.8014 108.52C13.721 111.494 21.9604 114.066 32.1291 114.267C42.2977 114.468 50.5371 112.218 50.6175 109.243C50.6979 106.269 42.5389 103.697 32.3702 103.496C22.2016 103.295 13.8817 105.546 13.8014 108.52Z"
        fill="#FFCA08"
      />
      <path
        d="M17.9001 108.6C17.8197 111.655 24.9739 112.459 32.2085 112.62C39.403 112.78 46.5572 112.178 46.5974 109.203C46.6778 106.229 39.5235 105.345 32.3291 105.184C25.0945 105.023 17.9403 105.546 17.9001 108.6Z"
        fill="#FA9C1E"
      />
      <path
        d="M7.20913 119.131L7.12875 123.874C6.92779 131.711 43.7038 132.475 43.9449 124.637L44.0253 119.895L7.20913 119.131Z"
        fill="#FA9C1E"
      />
      <path
        d="M7.20957 119.131C7.12918 122.105 15.3686 124.677 25.5373 124.878C35.7059 125.079 43.9453 122.828 44.0257 119.854C44.1061 116.88 35.9471 114.308 25.7784 114.107C15.6098 113.906 7.28995 116.157 7.20957 119.131Z"
        fill="#FFCA08"
      />
      <path
        d="M11.2682 119.211C11.1879 122.266 18.3421 123.07 25.5767 123.231C32.7711 123.391 39.9254 122.788 39.9656 119.814C40.0459 116.84 32.8917 115.956 25.6973 115.795C18.5029 115.634 11.3486 116.157 11.2682 119.211Z"
        fill="#FA9C1E"
      />
      <path
        d="M81.3634 100.923L81.283 105.666C81.0821 113.504 117.858 114.267 118.099 106.43L118.18 101.687L81.3634 100.923Z"
        fill="#FA9C1E"
      />
      <path
        d="M81.3639 100.923C81.2835 103.897 89.5229 106.47 99.6916 106.671C109.86 106.872 118.1 104.621 118.18 101.647C118.26 98.6725 110.101 96.1002 99.9327 95.8992C89.7641 95.6982 81.4442 97.949 81.3639 100.923Z"
        fill="#FFCA08"
      />
      <path
        d="M85.4626 101.004C85.3822 104.058 92.5364 104.862 99.7711 105.023C106.965 105.184 114.12 104.581 114.16 101.607C114.24 98.6324 107.086 97.7482 99.8916 97.5874C92.657 97.4267 85.5028 97.9492 85.4626 101.004Z"
        fill="#FA9C1E"
      />
      <path
        d="M81.0421 115.955L80.9618 120.698C80.7608 128.535 117.537 129.299 117.778 121.461L117.858 116.719L81.0421 115.955Z"
        fill="#FA9C1E"
      />
      <path
        d="M81.0426 115.955C80.9622 118.929 89.2016 121.502 99.3703 121.703C109.539 121.904 117.778 119.653 117.859 116.679C117.939 113.704 109.78 111.132 99.6114 110.931C89.4428 110.73 81.0828 113.021 81.0426 115.955Z"
        fill="#FFCA08"
      />
      <path
        d="M85.1013 116.036C85.0209 119.09 92.1751 119.894 99.4097 120.055C106.604 120.216 113.758 119.613 113.799 116.639C113.879 113.665 106.725 112.78 99.5303 112.62C92.2957 112.459 85.1816 113.021 85.1013 116.036Z"
        fill="#FA9C1E"
      />
      <path
        d="M109.257 105.063L109.177 109.806C108.976 117.644 145.752 118.407 145.993 110.57L146.033 105.827L109.257 105.063Z"
        fill="#FA9C1E"
      />
      <path
        d="M109.257 105.063C109.177 108.038 117.416 110.61 127.585 110.811C137.754 111.012 145.993 108.761 146.074 105.787C146.154 102.813 137.995 100.24 127.826 100.039C117.617 99.8384 109.298 102.089 109.257 105.063Z"
        fill="#FFCA08"
      />
      <path
        d="M113.316 105.144C113.236 108.199 120.39 109.002 127.625 109.163C134.819 109.324 141.973 108.721 142.013 105.747C142.094 102.773 134.94 101.888 127.745 101.728C120.511 101.567 113.356 102.089 113.316 105.144Z"
        fill="#FA9C1E"
      />
      <path
        d="M109.619 118.126L109.539 122.869C109.338 130.706 146.114 131.47 146.355 123.632L146.435 118.89L109.619 118.126Z"
        fill="#FA9C1E"
      />
      <path
        d="M109.62 118.126C109.539 121.1 117.779 123.673 127.947 123.874C138.116 124.074 146.355 121.824 146.436 118.849C146.516 115.875 138.357 113.303 128.189 113.102C117.98 112.941 109.66 115.152 109.62 118.126Z"
        fill="#FFCA08"
      />
      <path
        d="M113.678 118.206C113.598 121.261 120.752 122.065 127.987 122.226C135.181 122.386 142.336 121.783 142.376 118.809C142.456 115.835 135.302 114.951 128.107 114.79C120.873 114.629 113.759 115.192 113.678 118.206Z"
        fill="#FA9C1E"
      />
      <path
        d="M128.991 107.073L128.911 111.816C128.71 119.653 165.486 120.417 165.727 112.58L165.808 107.837L128.991 107.073Z"
        fill="#FA9C1E"
      />
      <path
        d="M128.992 107.073C128.911 110.047 137.151 112.62 147.319 112.821C157.488 113.022 165.728 110.771 165.808 107.797C165.888 104.822 157.729 102.25 147.561 102.049C137.392 101.848 129.072 104.099 128.992 107.073Z"
        fill="#FFCA08"
      />
      <path
        d="M133.05 107.154C132.97 110.208 140.124 111.012 147.359 111.173C154.553 111.334 161.708 110.731 161.748 107.757C161.828 104.782 154.674 103.898 147.48 103.737C140.285 103.577 133.131 104.099 133.05 107.154Z"
        fill="#FA9C1E"
      />
      <path
        d="M137.472 122.426L137.391 127.169C137.19 135.006 173.966 135.77 174.208 127.933L174.288 123.19L137.472 122.426Z"
        fill="#FA9C1E"
      />
      <path
        d="M137.472 122.426C137.392 125.401 145.631 127.973 155.8 128.174C165.969 128.375 174.208 126.124 174.288 123.15C174.369 120.176 166.21 117.603 156.041 117.402C145.872 117.242 137.553 119.452 137.472 122.426Z"
        fill="#FFCA08"
      />
      <path
        d="M141.531 122.507C141.451 125.561 148.605 126.365 155.839 126.526C163.034 126.687 170.188 126.084 170.228 123.11C170.309 120.135 163.154 119.251 155.96 119.09C148.766 118.93 141.611 119.452 141.531 122.507Z"
        fill="#FA9C1E"
      />
      <path
        d="M160.462 113.263L160.382 118.005C160.181 125.843 196.957 126.607 197.198 118.769L197.278 114.026L160.462 113.263Z"
        fill="#FA9C1E"
      />
      <path
        d="M160.462 113.263C160.382 116.237 168.622 118.809 178.79 119.01C188.959 119.211 197.198 116.96 197.279 113.986C197.359 111.012 189.2 108.44 179.031 108.239C168.822 108.038 160.503 110.288 160.462 113.263Z"
        fill="#FFCA08"
      />
      <path
        d="M164.521 113.343C164.441 116.398 171.595 117.202 178.83 117.362C186.024 117.523 193.178 116.92 193.218 113.946C193.299 110.972 186.145 110.088 178.95 109.927C171.716 109.766 164.602 110.289 164.521 113.343Z"
        fill="#FA9C1E"
      />
      <path
        d="M157.93 103.496L157.849 108.239C157.648 116.076 194.424 116.84 194.666 109.002L194.746 104.26L157.93 103.496Z"
        fill="#FA9C1E"
      />
      <path
        d="M157.93 103.496C157.85 106.47 166.089 109.043 176.258 109.244C186.427 109.444 194.666 107.194 194.746 104.219C194.827 101.245 186.668 98.6729 176.499 98.472C166.29 98.3112 157.97 100.562 157.93 103.496Z"
        fill="#FFCA08"
      />
      <path
        d="M161.989 103.617C161.909 106.671 169.063 107.475 176.297 107.636C183.492 107.797 190.646 107.194 190.686 104.22C190.767 101.245 183.612 100.361 176.418 100.2C169.183 99.9995 162.069 100.562 161.989 103.617Z"
        fill="#FA9C1E"
      />
      <path
        d="M172.801 126.165L172.721 130.907C172.52 138.745 209.296 139.508 209.537 131.671L209.617 126.928L172.801 126.165Z"
        fill="#FA9C1E"
      />
      <path
        d="M172.801 126.164C172.721 129.139 180.96 131.711 191.129 131.912C201.298 132.113 209.537 129.862 209.618 126.888C209.698 123.914 201.539 121.341 191.37 121.14C181.161 120.98 172.842 123.23 172.801 126.164Z"
        fill="#FFCA08"
      />
      <path
        d="M176.86 126.245C176.78 129.299 183.934 130.103 191.169 130.264C198.363 130.425 205.517 129.822 205.557 126.848C205.638 123.874 198.484 122.989 191.289 122.829C184.095 122.668 176.94 123.23 176.86 126.245Z"
        fill="#FA9C1E"
      />
      <path
        d="M115.889 100.924C115.728 107.917 121.717 113.705 129.233 113.866C136.709 114.026 142.898 108.48 143.059 101.486C143.22 94.4929 137.231 88.7052 129.755 88.5444C122.239 88.3837 116.05 93.9302 115.889 100.924Z"
        fill="#F0F1FF"
      />
      <path
        d="M120.511 105.867C122.199 108.721 125.495 110.65 129.313 110.731C135.06 110.851 139.843 106.631 139.964 101.366C140.044 98.2308 138.396 95.3772 135.864 93.6489C136.829 95.0958 137.351 96.8241 137.311 98.6328C137.191 103.898 132.408 108.038 126.66 107.917C124.369 107.917 122.239 107.154 120.511 105.867Z"
        fill="#D6D9F2"
      />
      <path
        d="M74.0892 96.9445C70.7533 96.9445 68.0202 99.6776 68.0202 103.014C68.0202 101.325 67.3369 99.8384 66.2517 98.7532C65.1666 97.668 63.6392 96.9445 61.9512 96.9445C63.6392 96.9445 65.1666 96.2613 66.2517 95.1359C67.3369 94.0507 68.0202 92.5234 68.0202 90.8755C68.0202 92.5636 68.7035 94.0507 69.7887 95.1359C70.914 96.2613 72.4414 96.9445 74.0892 96.9445Z"
        fill="white"
      />
      <path
        d="M64.2015 131.108C60.8656 131.108 58.1325 133.841 58.1325 137.177C58.1325 135.489 57.4492 134.002 56.3641 132.917C55.2789 131.832 53.7516 131.108 52.0635 131.108C53.7516 131.108 55.2789 130.425 56.3641 129.299C57.4492 128.214 58.1325 126.687 58.1325 125.039C58.1325 126.727 58.8158 128.214 59.901 129.299C61.0264 130.425 62.5537 131.108 64.2015 131.108Z"
        fill="white"
      />
      <path
        d="M114.321 121.703C108.574 121.703 103.912 126.365 103.912 132.113C103.912 129.259 102.746 126.647 100.897 124.798C99.0082 122.909 96.3956 121.743 93.542 121.743C96.3956 121.743 99.0483 120.537 100.897 118.689C102.786 116.799 103.912 114.227 103.912 111.374C103.912 114.227 105.077 116.84 106.926 118.689C108.815 120.497 111.428 121.703 114.321 121.703Z"
        fill="white"
      />
      <path
        d="M161.025 87.9816C157.689 87.9816 154.956 90.7147 154.956 94.0507C154.956 92.3626 154.272 90.8755 153.187 89.7903C152.102 88.7051 150.575 87.9816 148.887 87.9816C150.575 87.9816 152.102 87.2984 153.187 86.173C154.272 85.0878 154.956 83.5605 154.956 81.9126C154.956 83.6007 155.639 85.0878 156.724 86.173C157.809 87.2984 159.337 87.9816 161.025 87.9816Z"
        fill="white"
      />
      <path
        d="M151.137 122.145C147.801 122.145 145.068 124.878 145.068 128.214C145.068 126.526 144.385 125.039 143.3 123.954C142.214 122.869 140.687 122.145 138.999 122.145C140.687 122.145 142.214 121.462 143.3 120.337C144.385 119.251 145.068 117.724 145.068 116.076C145.068 117.764 145.751 119.251 146.837 120.337C147.962 121.462 149.489 122.145 151.137 122.145Z"
        fill="white"
      />
      <path
        d="M201.257 112.74C195.509 112.74 190.847 117.402 190.847 123.15C190.847 120.296 189.682 117.684 187.833 115.835C185.944 113.946 183.331 112.78 180.478 112.78C183.331 112.78 185.984 111.574 187.833 109.726C189.722 107.837 190.847 105.264 190.847 102.411C190.847 105.264 192.013 107.877 193.862 109.726C195.751 111.534 198.363 112.74 201.257 112.74Z"
        fill="white"
      />
      <path
        d="M236.788 128.737C233.452 128.737 230.718 131.47 230.718 134.806C230.718 133.117 230.035 131.63 228.95 130.545C227.865 129.46 226.337 128.737 224.649 128.737C226.337 128.737 227.865 128.053 228.95 126.928C230.035 125.843 230.718 124.315 230.718 122.667C230.718 124.356 231.402 125.843 232.487 126.928C233.612 128.053 235.14 128.737 236.788 128.737Z"
        fill="white"
      />
      <path
        d="M196.072 155.505C190.325 155.505 185.663 160.167 185.663 165.915C185.663 163.061 184.497 160.448 182.648 158.6C180.759 156.71 178.147 155.545 175.293 155.545C178.147 155.545 180.799 154.339 182.648 152.49C184.537 150.601 185.663 148.029 185.663 145.175C185.663 148.029 186.828 150.641 188.677 152.49C190.566 154.299 193.179 155.505 196.072 155.505Z"
        fill="white"
      />
    </svg>
  );
};

export default TresureSvg;
